// Single in-memory owner of the access/session token used for authenticated
// `olerexweb.*` API calls.
//
// Today it simply mirrors redux `login.token` (kept in sync from index.js), so
// `request()` has one place to source the token from instead of every caller
// threading it through the request body. This is the seam the planned silent
// token-refresh interceptor will own — see docs/auth-token-refresh-design.md.
let accessToken = null;

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
    accessToken = token || null;
};

export const clearAccessToken = () => {
    accessToken = null;
};
